import { Pencil1Icon } from '@radix-ui/react-icons'
import { DataList, Flex, IconButton, Text } from '@radix-ui/themes'
import { S2WGame } from '@Generated/back-office-client/src'
import { formatDailySpinLimit, formatPrizeRevealMethod } from './types'

const Item = ({ label, value }: { label: string; value: string }) => (
  <DataList.Item>
    <DataList.Label minWidth="120px">
      <Text size="1" weight="medium" color="gray">
        {label}
      </Text>
    </DataList.Label>
    <DataList.Value>
      <Text size="2">{value}</Text>
    </DataList.Value>
  </DataList.Item>
)

type GameDetailsProps = {
  game: S2WGame
  // Given only to users who can edit, so the edit button is hidden otherwise
  onEdit?: () => void
}

// The S2W game's settings, shown under its heading
export const GameDetails = ({ game, onEdit }: GameDetailsProps) => (
  <Flex gap="3" align="start">
    <DataList.Root size="1" orientation="horizontal" aria-label={`${game.name} settings`}>
      <Item label="Spin cost" value={`${game.pointCost} points`} />
      <Item label="Daily spin limit" value={formatDailySpinLimit(game)} />
      <Item label="Prize reveal" value={formatPrizeRevealMethod(game)} />
      <Item label="Theme" value={game.theme} />
      <Item
        label="Text limits"
        value={`Promo ${game.promoTextLimit} · Wheel ${game.wheelTextLimit} characters`}
      />
    </DataList.Root>
    {onEdit ? (
      <IconButton
        size="1"
        variant="ghost"
        aria-label={`Edit ${game.name} settings`}
        onClick={onEdit}>
        <Pencil1Icon />
      </IconButton>
    ) : null}
  </Flex>
)
